const SYMBOLS = { usd: "$", inr: "₹", eur: "€", gbp: "£" };

export function formatPrice(amount, currency = "usd") {
  const sym = SYMBOLS[(currency || "usd").toLowerCase()] || "";
  const rounded = Number.isInteger(amount) ? amount : Number(amount).toFixed(2);
  return `${sym}${rounded.toLocaleString ? amount.toLocaleString() : rounded}`;
}
